<div class="progress-bar" [class.visible]="visible">
  <div class="progress-bar__fill" [style.width.%]="fillWidth"></div>
</div>